import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import LayoutDetail from '../views/layout/Layout-Deail'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    meta: {title: '首页', icon: 'home'}
  },{
    path: '',
    component: LayoutDetail,
    children: [{
      path: '/fashion-handbags/:path/:id',
      name: 'product-detail',
      component: () => import('@/views/product/detail'),
      meta: {title: '产品页列表', icon: 'product'}
    },{
      path: '/fashion-handbags/:path',
      name: 'product',
      component: () => import('@/views/product/index'),
      meta: {title: '产品页列表', icon: 'product'}
    },{
      path: '/fashion-handbags/new-arrivals',
      name: 'product',
      component: () => import('@/views/product/index'),
      meta: {title: '产品页列表', icon: 'product'}
    },{
      path: '/fashion-handbags',
      name: 'product-all',
      component: () => import('@/views/product/index'),
      meta: {title: '产品页列表', icon: 'product'}
    },{
      path: 'about-us',
      name: 'about-us',
      component: () => import('@/views/cms/subject/detail'),
      meta: {title: '关于我们', icon: 'product'},
      beforeEnter: (to, from, next) => {
        to.params.id = 16
        next(true)
      }
    },{
      path: 'about-factory',
      name: 'about-factory',
      component: () => import('@/views/cms/subject/detail'),
      meta: {title: '关于我们', icon: 'product'},
      beforeEnter: (to, from, next) => {
        to.params.id = 18
        next(true)
      }
    },{
      path: 'about-production',
      name: 'about-production',
      component: () => import('@/views/cms/subject/detail'),
      meta: {title: '关于我们', icon: 'product'},
      beforeEnter: (to, from, next) => {
        to.params.id = 19
        next(true)
      }
    },{
      path: 'faq',
      name: 'faq',
      component: () => import('@/views/cms/subject/detail'),
      meta: {title: '关于我们', icon: 'product'},
      beforeEnter: (to, from, next) => {
        to.params.id = 17
        next(true)
      }
    },{
      path: 'contact',
      name: 'contact-us',
      component: () => import('@/views/cms/single-page/contact-us'),
      meta: {title: '关于我们', icon: 'product'}
    }],
  },{
    path: '/blog',
    component: LayoutDetail,
    redirect: '/blog/subject/list',
    children: [{
      path: 'subject/list',
      name: 'subject-list',
      component: () => import('@/views/cms/subject/index'),
      meta: {title: '文章列表', icon: 'product'}
    },{
      path: 'subject/info/:id',
      name: 'subject-detail',
      component: () => import('@/views/cms/subject/detail'),
      meta: {title: '文章内容', icon: 'product'}
    }],
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})

